import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quoting/canned/")({
  beforeLoad: () => {
    throw redirect({ to: "/templates/quotes" })
  },
})
